/**
 * kmfc1 → Gebruiker 1, kmfc2 → Gebruiker 2, etc.
 * Andere usernames (webvonk1, etc.) blijven ongewijzigd.
 */
const formatUsername = (username) => {
  if (!username) return 'Gebruiker';
  const match = username.match(/^kmfc(\d+)$/i);
  if (match) return `Gebruiker ${match[1]}`;
  return username;
};

export default formatUsername;
